import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../../services/account.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit {
  payment_trans_details: any = [];
  constructor(private route: ActivatedRoute, private accountService: AccountService) { }

  ngOnInit() {
    let id;
    this.route.parent.params.subscribe(params => {
      id = params['id'];
      this.accountService.getTestTransactionDetails(id)
      .subscribe(res => {
      this.payment_trans_details = res;

      });

    });
  }

}
